// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uZqW","toggle":"styles_toggle__2jg83","preview":"styles_preview__M2Rf8"};